const { Core } = Global;


customElements.define('moving-content', class extends Core {

    elements = {
        $: ['content']
    }

    render() {
        this.contentWidth = this.$('content').offsetWidth;
        //sanity check
        if (!this.contentWidth) {
            this.remove();
            return;
        }
        this._setContent();
        this.style.setProperty('--content-width', `${this.contentWidth}`);
         var needInterval = false;
         if (this.getAttribute('data-end-date') || this.getAttribute('data-start-date')) {
            needInterval = true;
          }
        if (needInterval) {
        if (this.getAttribute('data-end-date') || this.getAttribute('data-start-date')) {
                  if(this.getAttribute('data-start-date') != "" && this.getAttribute('data-start-date') != null){
                    var startDate = new Date(this.getAttribute('data-start-date'));
                  }else{
                    var startDate = Date.now();
                  }

                  if(this.getAttribute('data-end-date') != "" && this.getAttribute('data-end-date') != null){
                    var endDate = new Date(this.getAttribute('data-end-date'));
                  }else{
                    var endDate = new Date(24 * 3600 * 1000 * 365 * 99);
                  }
                  
                  
                  if (Date.now() < startDate || Date.now() > endDate) {
                    this.remove();
                  }
                }

           setInterval(() => {
                if (this.getAttribute('data-end-date') || this.getAttribute('data-start-date')) {
                  if(this.getAttribute('data-start-date') != "" && this.getAttribute('data-start-date') != null){
                    var startDate = new Date(this.getAttribute('data-start-date'));
                  }else{
                    var startDate = Date.now();
                  }

                  if(this.getAttribute('data-end-date') != "" && this.getAttribute('data-end-date') != null){
                    var endDate = new Date(this.getAttribute('data-end-date'));
                  }else{
                    var endDate = new Date(24 * 3600 * 1000 * 365 * 99);
                  }
                  
                  
                  if (Date.now() < startDate || Date.now() > endDate) {
                    this.remove();
                  }
                }
           },1000);
        }
      
        
    }

    _setContent() {
        const items = [...Array(this.duplicates)].map(this._cloneContent.bind(this));
        this.replaceChildren(...items);
    }

    _cloneContent() {
        return this.$('content').cloneNode(true);
    }

    get duplicates() {
        return Math.ceil(window.innerWidth / this.contentWidth) + 1;
    }
})